// src/context/BaseUrlContext.js
import React, { createContext, useContext } from 'react';

const BaseUrlContext = createContext();

export const BaseUrlProvider = ({ children }) => {
  const baseUrl = 'https://loandestination.in/system/api/'; // ✅ Your base URL here

  return (
    <BaseUrlContext.Provider value={{ baseUrl }}>
      {children}
    </BaseUrlContext.Provider>
  );
};

// Custom hook for using baseUrl
export const useBaseUrl = () => useContext(BaseUrlContext);
